// color design tokens export
export const tokensDark = {
  grey: {
    0: "#ffffff", // manually adjusted
    10: "#f6f6f6", // manually adjusted
    50: "#f0f0f0", // manually adjusted
    100: "#e0e0e0",
    200: "#c2c2c2",
    300: "#a3a3a3",
    400: "#858585",
    500: "#666666",
    600: "#525252",
    700: "#3d3d3d",
    800: "#292929",
    900: "#141414",
    1000: "#000000", // manually adjusted
  },
  // secondary: {
  //   0: "#ffffff", // manually adjusted
  //   10: "#f6f6f6", // manually adjusted
  //   50: "#f0f0f0", // manually adjusted
  //   100: "#e0e0e0",
  //   200: "#c2c2c2",
  //   300: "#a3a3a3",
  //   400: "#858585",
  //   500: "#666666",
  //   600: "#525252",
  //   700: "#3d3d3d",
  //   800: "#292929",
  //   900: "#141414",
  //   1000: "#000000",
  // },

  primary: {
    0: "#ffffff", // manually adjusted
    10: "#f6f6f6", // manually adjusted
    50: "#f0f0f0", // manually adjusted
    100: "#d9d9dc",
    200: "#b3b3b9",
    300: "#8e8e96",
    400: "#686873",
    500: "#424250",
    600: "#353540",
    700: "#282830",
    800: "#1a1a20",
    900: "#0d0d10",
  },
  secondary: {
      100: "#d1d1d2",
      200: "#a3a3a6",
      300: "#767679",
      400: "#48484d",
      500: "#1a1a20",
      600: "#15151a",
      700: "#101013",
      800: "#0a0a0d",
      900: "#050506"
},
  // secondary: {
  //   100: "#d7e3f7",
  //   200: "#afc6ee",
  //   300: "#86aae6",
  //   400: "#5e8ddd",
  //   500: "#3671d5",
  //   600: "#2b5aaa",
  //   700: "#204480",
  //   800: "#162d55",
  //   900: "#0b172b",
  // },
};

// function that reverses the color palette
function reverseTokens(tokensDark) {
  const reversedTokens = {};
  Object.entries(tokensDark).forEach(([key, val]) => {
    const keys = Object.keys(val);
    const values = Object.values(val);
    const length = keys.length;
    const reversedObj = {};
    for (let i = 0; i < length; i++) {
      reversedObj[keys[i]] = values[length - i - 1];
    }
    reversedTokens[key] = reversedObj;
  });
  return reversedTokens;
}
export const tokensLight = reverseTokens(tokensDark);

// mui theme settings
export const themeSettings = (mode) => {
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            // palette values for dark mode
            primary: {
              ...tokensDark.primary,
              main: tokensDark.primary[200],
              light: tokensDark.primary[100],
            },
            secondary: {
              ...tokensDark.secondary,
              main: tokensDark.secondary[300],
              light: tokensDark.secondary[200],
            },
            neutral: {
              ...tokensDark.grey,
              main: tokensDark.grey[500],
            },
            background: {
              default: tokensDark.primary[600],
              alt: tokensDark.primary[500],
            },
          }
        : {
            // palette values for light mode
            primary: {
              ...tokensLight.primary,
              main: tokensDark.primary[500],
              light: tokensDark.primary[300],
            },
            secondary: {
              ...tokensLight.secondary,
              main: tokensDark.secondary[500],
              light: tokensDark.secondary[400],
            },
            neutral: {
              ...tokensLight.grey,
              main: tokensDark.grey[500],
            },
            background: {
              default: tokensDark.grey[0],
              alt: tokensDark.grey[50],
            },
          }),
    },
    typography: {
      fontFamily: ["Plus Jakarta Sans", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Plus Jakarta Sans", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Plus Jakarta Sans", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Plus Jakarta Sans", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Plus Jakarta Sans", "sans-serif"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Plus Jakarta Sans", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Plus Jakarta Sans", "sans-serif"].join(","),
        fontSize: 14,
      },
    },
  };
};
